import React from "react";
import { string, func } from "prop-types";
import { WithGoogleLogin } from "@quintype/components";

import SocialAuthButton from "../social-auth-button";

import { getUser } from "../../utils/api";
import { setAccessTypeUser, getUserSubscriptions } from "../../helper/access-type";

const GoogleAuth = ({ googleClientId, setMember, setLoading, closePopup, setUserPlans }) => {
  const socialLogin = (e, login) => {
    e.preventDefault();

    setLoading(true);

    login()
      .then(() => {
        // Fetch the user details
        getUser()
          .then(result => {
            setMember(result.user);

            closePopup && closePopup();
            const { user } = result;

            setAccessTypeUser(user.email, user["phone-number"], user.id, user.name).then(() => {
              getUserSubscriptions().then(data => {
                setUserPlans(data.subscriptions);

                setLoading(false);
              });
            });
          })
          .catch(() => setLoading(false));
      })
      .catch(() => setLoading(false));
  };

  return (
    <WithGoogleLogin clientId={googleClientId} scope="email" emailMandatory loginHandler="bridgekeeper">
      {({ login, serverSideLoginPath }) => (
        <SocialAuthButton type="google" href={serverSideLoginPath} onSocialClick={e => socialLogin(e, login)} />
      )}
    </WithGoogleLogin>
  );
};

GoogleAuth.propTypes = {
  googleClientId: string.isRequired,
  setMember: func.isRequired,
  setLoading: func.isRequired,
  closePopup: func,
  setUserPlans: func
};

export default GoogleAuth;
